import { ChangeEvent, KeyboardEvent, useCallback, useState } from 'react';

import { isEmpty } from '~utils/lodash/isEmpty';

import * as S from './style';

interface Props {
  defaultValue?: string[];
  onChange?: (hashtag: string[]) => void;
}

export default function InputHashtag({ onChange, defaultValue = [] }: Props) {
  const [currentHashtag, setCurrentHashTag] = useState<string>('');
  const [hashtags, setHashTags] = useState<string[]>(defaultValue);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentHashTag(e.target.value.replace(/\s+/, ''));
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (
      (e.key === 'Space' ||
        e.code === 'Space' ||
        e.key === 'Enter' ||
        e.code === 'Enter' ||
        e.keyCode === 32 ||
        e.keyCode === 13) &&
      !isEmpty(currentHashtag.replace(/\s+/, ''))
    ) {
      e.stopPropagation();
      e.preventDefault();
      setCurrentHashTag('');
      const newState = [...hashtags, currentHashtag];
      setHashTags(newState);

      if (onChange) {
        onChange(newState);
      }
    }
  };

  const handleDeleteTag = useCallback(
    (index: number) => {
      const newState = [...hashtags];
      newState.splice(index, 1);
      setHashTags(newState);

      if (onChange) {
        onChange(newState);
      }
    },
    [hashtags],
  );

  return (
    <S.Wrapper>
      {hashtags.map((tag, index) => (
        <S.HashTag key={index}>
          {tag}
          <S.Delete onClick={() => handleDeleteTag(index)} />
        </S.HashTag>
      ))}

      <S.Input
        placeholder='#'
        onChange={handleChange}
        onKeyUp={handleKeyDown}
        value={currentHashtag}
        expand={hashtags.length === 0}
      />
    </S.Wrapper>
  );
}
